import { render, staticRenderFns } from "./SubscriptionIcon.vue?vue&type=template&id=591a7e00&lang=true"
import script from "./SubscriptionIcon.vue?vue&type=script&lang=js"
export * from "./SubscriptionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports